<template>
  <div v-if="isReady">
    <template v-if="electionPeriod">
      <icon-router-link icon="chevron-left" to="/pk/forside">Tilbake</icon-router-link>
      <div class="uppercase font-bold text-gray-500 mt-6">Valgperiode: {{ electionPeriod.name }}</div>
      <template v-if="practicePeriods.length > 0">

        <!-- header -->
        <div class="flex justify-between items-center mb-4">
          <h1 class="text-4xl font-bold tracking-tight leading-none text-gray-600">Studenter</h1>
          <div class="flex items-center">
            <select v-model="selectedPracticePeriodId" class="bg-white font-bold focus:bg-white">
              <option
                v-for="practicePeriod in practicePeriods"
                :key="practicePeriod.practicePeriodId"
                :value="practicePeriod.practicePeriodId">
                  {{ practicePeriod.name }}
                  <template v-if="students.length > 0 && practicePeriod.practicePeriodId === selectedPracticePeriodId">
                    ({{ students.length }})
                  </template>
                </option>
            </select>
            <router-link class="ml-6 btn btn-primary" :to="{ name: 'pk-students-create', params: { id: selectedPracticePeriodId }  }">Opprett</router-link>
            <a href="#" @click.prevent="onDelete" class="ml-4 btn btn-primary" v-if="selected.length > 0">
              <font-awesome-icon :icon="['far', 'trash']" />
            </a>
          </div>
        </div>

        <!-- table -->
        <panel class="p-4 mb-8">
          <data-table
            :headers="headers"
            :items="students"
            :showSelect="true"
            v-model="selected"
            identifier="studentId"
            :search="search"
            v-if="students.length > 0"
            @click="onClick">
          </data-table>
          <div class="text-center italic" v-else>
            Ingen studenter registrert.
          </div>
        </panel>
      </template>
      <template v-else>
        Praksisperiode(r) må registreres før studenter.
      </template>
    </template>
    <template v-else>
      Ingen aktiv valgperiode.
    </template>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'pk-students-list',
  data () {
    return {
      isReady: false,
      search: '',
      headers: [
        { text: 'Fornavn', align: 'left', value: 'firstName' },
        { text: 'Etternavn', align: 'left', value: 'lastName' },
        { text: 'Telefon', align: 'left', value: 'phone' },
        { text: 'Epost', align: 'left', value: 'email' }
      ],
      electionPeriod: null,
      practicePeriods: [],
      students: [],
      selectedPracticePeriodId: null,
      selected: [],
    }
  },
  methods: {
    onClick (student) {
      const params = {
        id: this.selectedPracticePeriodId,
        studentId: student.studentId
      }
      this.$router.push({ name: 'pk-students-edit', params })
    },
    async onDelete () {
      for (let i = 0; i < this.selected.length; i++) {
        await api.pk.deletePracticePeriodStudent(this.selectedPracticePeriodId, this.selected[i].studentId)
      }
      this.$toasted.show(`${ this.selected.length } student${ this.selected.length > 1 ? 'er' : '' } slettet!`)
      this.students = await api.pk.getPracticePeriodStudents(this.selectedPracticePeriodId)
    }
  },
  async created () {
    this.electionPeriod = await api.pk.getElectionPeriod()
    this.practicePeriods = await api.pk.getPracticePeriods()

    if (this.practicePeriods.length > 0) {
      this.selectedPracticePeriodId = this.practicePeriods[0].practicePeriodId
    }

    this.isReady = true
  },
  watch: {
    'selectedPracticePeriodId': async function (val) {
      this.students = await api.pk.getPracticePeriodStudents(val)
    }
  }
}
</script>